import Util from '@/lib/util'

export default [
    {
        title:Util.L('Status'),
        width:150,

        fixed:'left',
        key:'statusName'
  },{
        title:Util.L('Current'),
        width:100,

        key:'current',
         fixed:'left',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.current));
        }
  },{
        title:Util.L('H8'),
        width:70,

        key:'h8',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h8));
        }
  },{
        title:Util.L('H9'),
        width:70,

        key:'h9',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h9));
        }
  },{
        title:Util.L('H10'),
        width:70,

        key:'h10',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h10));
        }
  },{
        title:Util.L('H11'),
        width:70,

        key:'h11',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h11));
        }
  },{
        title:Util.L('H12'),
        width:70,

        key:'h12',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h12));
        }
  },{
        title:Util.L('H13'),
        width:70,

        key:'h13',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h13));
        }
  },{
        title:Util.L('H14'),
        width:70,

        key:'h14',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h14));
        }
  },{
        title:Util.L('H15'),
        width:70,

        key:'H15',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h15));
        }
  },{
        title:Util.L('H16'),
        width:70,

        key:'h16',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h16));
        }
  },{
        title:Util.L('H17'),
        width:70,

        key:'h17',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h17));
        }
  },{
        title:Util.L('H18'),
        width:70,

        key:'h18',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h18));
        }
  },{
        title:Util.L('H19'),
        width:70,

        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h19));
        }
  },{
        title:Util.L('H20'),
        width:70,

        key:'h20',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h20));
        }
  },{
        title:Util.L('H21'),
        width:70,

        key:'h21',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h21));
        }
  },{
        title:Util.L('H22'),
        width:70,

        key:'h22',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h22));
        }
  },{
        title:Util.L('H23'),
        width:70,

        key:'h23',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h23));
        }
  },{
        title:Util.L('H24'),
        width:70,

        key:'h24',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.h24));
        }
  }
]